import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=5115f869"
import script from "./LayoutPage.vue?vue&type=script&lang=ts"
export * from "./LayoutPage.vue?vue&type=script&lang=ts"
import style0 from "./LayoutPage.vue?vue&type=style&index=0&id=5115f869&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports